/**
 * @generated SignedSource<<1c0943aebb3c4390bc04c42f6b60049f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectOverviewContainer_searchResult$data = {
  readonly project: {
    readonly overview: ReadonlyArray<string | null> | null;
    readonly tradeCoverPhoto: {
      readonly url: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_searchResult">;
  readonly " $fragmentType": "ProjectOverviewContainer_searchResult";
};
export type ProjectOverviewContainer_searchResult$key = {
  readonly " $data"?: ProjectOverviewContainer_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectOverviewContainer_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectOverviewContainer_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overview",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhoto",
          "kind": "LinkedField",
          "name": "tradeCoverPhoto",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectHeader_searchResult"
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "82807127a3e6bc6a3a8b8ecba5a9bc84";

export default node;
